import { Box } from "@mui/material";
import type { MouseEvent, ReactNode } from "react";

const showFullValueWhenTruncated = (event: MouseEvent<HTMLElement>) => {
	const element = event.currentTarget;
	element.title =
		element.scrollWidth > element.clientWidth
			? (element.textContent ?? "")
			: "";
};

export const CellValue = ({ children }: { children: ReactNode }) => (
	<Box
		component="span"
		onMouseEnter={showFullValueWhenTruncated}
		sx={{
			display: "block",
			minWidth: 0,
			overflow: "hidden",
			textOverflow: "ellipsis",
			whiteSpace: "nowrap",
		}}
	>
		{children}
	</Box>
);
